<script>
  import { crossfade, fade } from "svelte/transition";
  import ScannerLink from "@/components/ScannerLink.svelte";

  export let routes, route, scoped, searchText, send;
  $searchText = "";
</script>

<div
  class="absolute inset-0 flex flex-wrap justify-center content-center"
  in:fade
  out:send={{ key: 'background' }}>
  <div>
    <div class="my-8">
      <input
        id="search-big"
        out:send={{ key: 'searchBox' }}
        type="text"
        bind:value={$searchText}
        class="text-4xl shadow-inner outline-none text-center rounded-lg
        bg-gray-200"
        placeholder="søg" />
    </div>
  </div>
  <div class="flex w-full justify-center">
    <ScannerLink />
  </div>
  
</div>
